module.exports = __webpack_public_path__ + "media/evolve/assets/icons/atlas/bell-838e473015311efde4fe7329ed961f11.svg";